// extracted by mini-css-extract-plugin
export var footerColumn = "styles-module--footerColumn--27c85";
export var footerLinksContainer = "styles-module--footerLinksContainer--a3fab";
export var linkTitle = "styles-module--linkTitle--5e620";
export var sublink = "styles-module--sublink--4802b";
export var sublinksContainer = "styles-module--sublinksContainer--0d148";